import React, { Component } from 'react';
import '../css/ticket.css'
import { FORMAT_NUMBER, CURRENCY, SYMBOL, _ROUND } from '../libs/utils/Const';
import { ValidationModal } from '../components/index';
import '../css/validations.css'
import moment from "moment";
import { PayMethodCounter } from "./NewOrder";


class MoneyMovements extends Component {


    ValidateAmount = (value) => {
        const { showAlert } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Cantidad invalida', timeOut: 2000 });
            return false;
        }
        return true;
    }

    SumOfAmounts = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel } = this.props;
        let totalAmount = 0;
        for (const payAdded of newOrderModel.MoneyMovements) {
            if (Number(payAdded.TypeMethod) !== 117) {
                totalAmount = totalAmount + Number(payAdded.Amount);
            }

        }
        newOrderModel.TotalMoneyMovement = totalAmount;

        await RefreshOrder(newOrderModel);
        await this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 0; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            // if (tableReg.rows[i].classList.contains("noSearch")) {
            //     continue;
            // }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
        // mostramos las coincidencias
        const lastTR = tableReg.rows[tableReg.rows.length - 1];
        const td = lastTR.querySelector("td");
        lastTR.classList.remove("hide", "red");
        if (searchText == "") {
            lastTR.classList.add("hide");
        } else if (total) {
            // td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");
        } else {
            // lastTR.classList.add("red");
            // td.innerHTML="No se han encontrado coincidencias";
        }
    }

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        const { RefreshPaymentSaleModel, } = this.props;
        RefreshPaymentSaleModel(PaymentSaleModel);
    }

    //#region ######### CHANGE PAYMENT GENERAL FIELDS ############################################################ 
    ChangeAmount = (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "warning", message: `Agregue un valor valido` });
            return
        }

        PaymentSaleModel.Amount = Number(value);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ChangeTypePayMethod = (payMethod) => {
        const { PaymentSaleModel, newOrderModel } = this.props;
        PaymentSaleModel.idPMBO = payMethod.idPMBO;
        PaymentSaleModel.PM_Name = payMethod.name;
        PaymentSaleModel.PM_Code = payMethod.idAPMBO;
        PaymentSaleModel.TypeMethod = payMethod.type;
        PaymentSaleModel.AcctCode = payMethod.AcctCode;
        PaymentSaleModel.CreditCard = payMethod.idCard || null;
        PaymentSaleModel.PaycheckNum = '';
        PaymentSaleModel.DatePaycheck = moment(new Date()).format("YYYY-MM-DD");
        PaymentSaleModel.BankCode = '';
        PaymentSaleModel.BankName = '';

        PaymentSaleModel.CardNum = '';
        PaymentSaleModel.VoucherNum = '';
        PaymentSaleModel.Indentification = '';
        PaymentSaleModel.PhoneNum = '';

        PaymentSaleModel.TransferNum = '';
        PaymentSaleModel.PayAccountNum = '';
        PaymentSaleModel.ReturnFolio = '';
        PaymentSaleModel.AvailableAmount = 0;

        // PaymentSaleModel.Amount = Number(0);
        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount);

        PaymentSaleModel.auxObjDP = {};
        PaymentSaleModel.DocEntryDP = '';
        PaymentSaleModel.AmountDP = 0;
        PaymentSaleModel.NumAtCardDP = '';
        this.RefreshPaymentSaleModel(PaymentSaleModel);

    }
    //#endregion

    //#region ######### CHANGE FIELDS PAYCHECKS ############################################################ 
    ChangePaycheckNum = (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.PaycheckNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ChangeDatePayCheck = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.DatePaycheck = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeBank = async (bankCode) => {
        const { PaymentSaleModel, BankAccounts } = this.props;
        const found = await BankAccounts.find(account => account.BankCode === bankCode);
        PaymentSaleModel.BankCode = found.BankCode;
        PaymentSaleModel.BankName = found.BankName;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    }
    //#endregion

    //#region ######### CHANGE FIELDS CARD CREDIT OR DEBIT ############################################################ 
    ChangeCardNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.CardNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeVoucherNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.VoucherNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeIndentification = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.Indentification = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePhoneNum = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        PaymentSaleModel.PhoneNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeValidCard = async (value) => {
        const { PaymentSaleModel, showAlert } = this.props;
        value = value.replace('/', '');
        if (isNaN(value) || value.includes('.')) {
            showAlert({ type: 'info', message: 'Caracter inválido' });
            return;
        }
        if (value.length > 2) {
            if (value.slice(0, 2) > 12) {
                showAlert({ type: 'info', message: 'Fecha incorrecta' });
                return;
            }
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        PaymentSaleModel.CardValid = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    //#endregion

    //#region ######### CHANGE FIELDS CARDS AND RETURNS ############################################################ 
    ChangeTransferNum = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.TransferNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangePayAccountNum = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.PayAccountNum = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };

    ChangeReturnFolio = async (value) => {
        const { PaymentSaleModel, RefreshReturnFolioAmount } = this.props;
        PaymentSaleModel.ReturnFolio = value;
        this.RefreshPaymentSaleModel(PaymentSaleModel);
        RefreshReturnFolioAmount(0)
    };

    ChangeReturnAvailableAmount = async (value) => {
        const { PaymentSaleModel } = this.props;
        PaymentSaleModel.AvailableAmount = Number(value);
        this.RefreshPaymentSaleModel(PaymentSaleModel);
    };
    //#endregion

    //#region ######### ADD OR REMOVE METHOD ############################################################ 
    addingPaymentSale = async () => {
        const { RefreshOrder, newOrderModel, PaymentSaleModel, showAlert, AddPay, ReturnFolioAmount } = this.props;
        let auxPaymentSaleModel = new PayMethodCounter();
        if (PaymentSaleModel.Amount === '' || Number(PaymentSaleModel.Amount) === 0) {
            showAlert({ type: "warning", message: `No es posible dejar el monto vació` });
            return
        }
        if (PaymentSaleModel.TypeMethod === '') {
            showAlert({ type: "warning", message: `No has seleccionado un método de pago` });
            return
        }

        let isCredit = newOrderModel.MoneyMovements.find((paymentMethod) => Number(paymentMethod.TypeMethod) === -1);
        if ((Number(PaymentSaleModel.TypeMethod) !== -1 && isCredit) || (Number(PaymentSaleModel.TypeMethod) === -1 && newOrderModel.MoneyMovements.length > 0)) {
            showAlert({ type: "warning", message: `No puedes utilizar métodos de pago distintos si utilizas crédito` });
            return
        }

        switch (Number(PaymentSaleModel.TypeMethod)) {
            case 1: // checks
                if (PaymentSaleModel.PaycheckNum === '') {
                    showAlert({ type: "warning", message: `El campo de cheque esta vació` });
                    return
                }
                if (PaymentSaleModel.BankCode === '') {
                    showAlert({ type: "warning", message: `No has seleccionado un banco para el pago con cheque` });
                    return
                }
                break;
            case 2: //credit cards
                if (PaymentSaleModel.CardNum === '') {
                    showAlert({ type: "warning", message: `El número de tarjeta esta vació` });
                    return
                }
                if (PaymentSaleModel.VoucherNum === '') {
                    showAlert({ type: "warning", message: `El número de autorización esta vació` });
                    return
                }
                if (PaymentSaleModel.Indentification === '') {
                    showAlert({ type: "warning", message: `El número de identificación esta vació` });
                    return
                }
                if (PaymentSaleModel.PhoneNum === '') {
                    showAlert({ type: "warning", message: `El número de teléfono esta vació` });
                    return
                }
                if (PaymentSaleModel.CardValid.length < 5) {
                    showAlert({ type: "warning", message: `La fecha de vencimiento de la tarjeta esta incompleta` });
                    return
                }

                break;
            case 3://transfers
                if (PaymentSaleModel.TransferNum === '') {
                    showAlert({ type: "warning", message: `El número de transferencia esta vació` });
                    return
                }
                if (PaymentSaleModel.PayAccountNum === '') {
                    showAlert({ type: "warning", message: `El número de cuenta de pago esta vació` });
                    return
                }
                break;
            case 4://devolution
                if (PaymentSaleModel.ReturnFolio === '') {
                    showAlert({ type: "warning", message: `El folio esta vació` });
                    return
                }
                if (Number(PaymentSaleModel.Amount) > Number(ReturnFolioAmount)) {
                    showAlert({ type: "warning", message: `No puedes tomar un monto mayor al disponible.` });
                    return
                }
                PaymentSaleModel.AvailableAmount = ReturnFolioAmount;


                break;
            case 117://facturas de anticipo
                if (Number(PaymentSaleModel.Amount) > PaymentSaleModel.auxObjDP.DocTotal) {
                    showAlert({ type: "error", message: `No puedes aumentar el valor de una factura registrada` });
                    return
                }
                PaymentSaleModel.PM_Name += ' - ' + PaymentSaleModel.auxObjDP.NumAtCard || 'XXXXXXXX';
                PaymentSaleModel.AmountDP = Number(PaymentSaleModel.Amount);
                break;
            case 14://Nota de crédito
                if (Number(PaymentSaleModel.Amount) > PaymentSaleModel.auxObjCN.DocTotal) {
                    showAlert({ type: "error", message: `No puedes aumentar el valor de una Nota de crédito registrada` });
                    return
                }
                break;
            case -1://Crédito
                if (Number(PaymentSaleModel.Amount) > newOrderModel.Credit) {
                    showAlert({ type: "error", message: `Crédito excedido` });
                }
                newOrderModel.AvailableCredit = newOrderModel.Credit - Number(PaymentSaleModel.Amount);
                break;
            default:
                break;
        }
        let newArray = newOrderModel.MoneyMovements;
        newArray.push(PaymentSaleModel);
        newOrderModel.MoneyMovements = newArray;
        await RefreshOrder(newOrderModel);
        this.RefreshPaymentSaleModel(auxPaymentSaleModel);

        this.SumOfAmounts();
        AddPay();
    }

    RemovePaymentSale = async (indexPayment) => {
        const { RefreshOrder, newOrderModel, AddPay} = this.props;
        let newPagos = [];
        if (Number(newOrderModel.MoneyMovements[indexPayment].TypeMethod) === -1) {
            newOrderModel.AvailableCredit += Number(newOrderModel.MoneyMovements[indexPayment].Amount);
        }

        for (let index = 0; index < newOrderModel.MoneyMovements.length; index++) {
            const pagos = newOrderModel.MoneyMovements[index];
            if (indexPayment === index && pagos.TypeMethod === '117') {
                newOrderModel.Total = Number(newOrderModel.Total) + Number(pagos.AmountDP) + Number(Number(pagos.AmountDP * Number(newOrderModel.TaxRate / 100)).toFixed(2));
                newOrderModel.Subtotal = Number(newOrderModel.Subtotal) + Number(pagos.AmountDP);
            }
            if (indexPayment !== index) {
                newPagos.push(pagos);
            }
        }
        newOrderModel.MoneyMovements = newPagos;
        await RefreshOrder(newOrderModel);
        await this.SumOfAmounts();
        AddPay();
    }
    //#endregion

    findInName(word, name) {
        let response = name.toUpperCase().includes(word)
        return (response)
    }

    render() {
        let { AvailablePayments } = this.props
        const {
            newOrderModel,
            // ValidateDocument,
            CancelMoneyMovement,
            cashMovementModel,
            PaymentSaleModel,
            BankAccounts,
            // CreateDocument,
            addingPay,
            AddPay,
            Action,
            // DownPayments,
            // CreditNotes,
            // SearchReturnFolioAmount,
            // ReturnFolioAmount,
            // requireInvoice,
            // creditPay,
            // creditNotesPay,
            SendCashMovement,
            ChangeComment
        } = this.props;
        // let addingPay=true;

        if (AvailablePayments) {
            AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
            AvailablePayments = AvailablePayments.filter((payment) => Number(payment.type) !== 4);
        }
        
        return (
            <div>
                <div className="modal fade" id="moneyMovementsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="billModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content" style={{boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px"}}>
                            <div className="modal-body p-3">
                                <form>
                                    
                                    <div className="">
                                        <h3 className="title">{Action && Number(Action) === 1 ? 'Entrada ' : 'Salida '}de dinero</h3>
                                        
                                        
                                        {addingPay === true &&
                                            <div className="row mt-2">
                                                <div className='col-12'>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Buscar método de pago: "
                                                        id="paymentSearch"
                                                        onKeyUp={() => this.DoSearch("payments", "paymentSearch")}
                                                    />
                                                    <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "130px", minHeight: "166px", overflowY: "scroll" }}>
                                                        <table id="payments" className="w-100">
                                                            <tbody>
                                                                {AvailablePayments && AvailablePayments.length > 0 &&
                                                                    AvailablePayments.map((payMethod, index) => {
                                                                        return (
                                                                            <tr key={index} className='m-1' style={{ boxShadow: "none" }}>
                                                                                <td className="text-center" style={{ width: "60px" }}>
                                                                                    <input
                                                                                        className='m-2'
                                                                                        type="radio"
                                                                                        checked={PaymentSaleModel.idPMBO === payMethod.idPMBO ? true : false}
                                                                                        onChange={() => this.ChangeTypePayMethod(payMethod)}
                                                                                    />
                                                                                </td>
                                                                                <td className='p-2 text-center' style={{ width: "60px" }}>
                                                                                    <i className={
                                                                                        this.findInName("EFECTIVO", payMethod.name) ? "fa fa-money" :
                                                                                            // this.findInName("TARJ",payMethod.name)?"fa fa-credit-card":
                                                                                            this.findInName("CHEQUE", payMethod.name) ? "fa fa-keyboard-o" :
                                                                                                this.findInName("TRANS", payMethod.name) ? "fa fa-exchange" :
                                                                                                    this.findInName("CRÉDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                        this.findInName("CREDITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                            this.findInName("DEBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                this.findInName("DÉBITO", payMethod.name) ? "fa fa-credit-card" :
                                                                                                                    this.findInName("DEVOLUCIÓN", payMethod.name) ? "fa fa-refresh" :
                                                                                                                        ""
                                                                                    }
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                </td>
                                                                                <td className='p-2 text-left' style={{ fontSize: "15px" }}> {payMethod.name.toUpperCase() || ''}</td>

                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        }
                                        {/* PAYMETHOD CHEQUE */}
                                        {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 1) && addingPay === true &&
                                            <>
                                                <div className="row mt-3">
                                                    <div className="col-12 col-md-6 mb-2 mb-md-0">
                                                        <label className="form-label">Cheque: </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={PaymentSaleModel.PaycheckNum || ''}
                                                            onChange={(event) => this.ChangePaycheckNum(event.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <label className="form-label">Fecha: </label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            max='9999-12-31'
                                                            value={PaymentSaleModel.DatePaycheck || ''}
                                                            onChange={(event) => this.ChangeDatePayCheck(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-12">
                                                        <label className="form-label">Banco: </label>
                                                        <select
                                                            name="select"
                                                            className="form-control"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                            value={PaymentSaleModel.BankCode || ''}
                                                            onChange={(event) => this.ChangeBank(event.target.value)}
                                                        >
                                                            <option value="">Seleccionar banco</option>
                                                            {!!BankAccounts && BankAccounts.map(bank => {
                                                                return (
                                                                    <option value={bank.BankCode}>{`${bank.BankCode} ${bank.BankName}`}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {/* PAYMETHOD TARJETA */}
                                        {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 2) && addingPay === true &&
                                            <>
                                                <div className="row mt-3">
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Tarjeta: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.CardNum || ''}
                                                                    onChange={(event) => this.ChangeCardNum(event.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Autorización: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.VoucherNum || ''}
                                                                    onChange={(event) => this.ChangeVoucherNum(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Identificación: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.Indentification || ''}
                                                                    onChange={(event) => this.ChangeIndentification(event.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Teléfono: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.PhoneNum || ''}
                                                                    onChange={(event) => this.ChangePhoneNum(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">Válido hasta: </label>
                                                                <input
                                                                    type=" text"
                                                                    className="form-control btn-outline-secondary"
                                                                    placeholder='MM/AA'
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    maxLength="5"
                                                                    value={PaymentSaleModel.CardValid || ''}
                                                                    onChange={(event) => this.ChangeValidCard(event.nativeEvent.target.value)}
                                                                />
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {/* PAYMETHOD TRANSFERENCIA */}
                                        {PaymentSaleModel && (Number(PaymentSaleModel.TypeMethod) === 3) && addingPay === true &&
                                            <>
                                                <div className="row mt-3">
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Transferencia: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.TransferNum || ''}
                                                                    onChange={(event) => this.ChangeTransferNum(event.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">No. Cuenta de pago: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={PaymentSaleModel.PayAccountNum || ''}
                                                                    onChange={(event) => this.ChangePayAccountNum(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row" >
                                                            <div className="col-12 col-md-6 mb-2">
                                                                <label className="form-label">Fecha: </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="date"
                                                                    max='9999-12-31'
                                                                    value={PaymentSaleModel.DatePaycheck || ''}
                                                                    onChange={(event) => this.ChangeDatePayCheck(event.target.value)}
                                                                />
                                                    </div>
                                                </div>
                                            </>
                                        }



                                        {/* IMPORTE */}
                                        {addingPay === true &&
                                            <div className="row mt-3">
                                                <div className="col-12">
                                                    <label className="form-label">Importe: </label>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min={0}
                                                        // disabled={Number(PaymentSaleModel.TypeMethod) === -1 ? true : false}
                                                        value={PaymentSaleModel.Amount || ''}
                                                        placeholder={PaymentSaleModel.Amount || 0}
                                                        onChange={(event) => this.ChangeAmount(event.nativeEvent.target.value)}
                                                        onKeyPress={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                this.addingPaymentSale();

                                                            }
                                                        }}
                                                    />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        onClick={() => this.addingPaymentSale()}
                                                        className={Action && Number(Action) === 1 ?"btn btn-outline-success":"btn btn-outline-danger"}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />

                                                    </button>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        }
                                        {/* MÉTODOS DE PAGO AGREGADOS */}
                                        {addingPay !== true &&
                                            <div className="row mt-2">
                                                <div className='col-12'>

                                                    <div className='card text-center mt-3' style={{ boxShadow: "none", maxHeight: "300px", overflowY: "scroll" }}>
                                                        <table className="table table-striped table-hover table-sm" id="payments">
                                                            <tbody>
                                                                {newOrderModel && newOrderModel.MoneyMovements.length > 0 &&
                                                                    newOrderModel.MoneyMovements.map((payMethod, index) => {
                                                                        return (
                                                                            <tr key={index} style={{ boxShadow: "none" }}>

                                                                                <td className='text-center' style={{ width: "60px" }}>
                                                                                    <i className={
                                                                                        this.findInName("EFECTIVO", payMethod.PM_Name) ? "fa fa-money" :
                                                                                            this.findInName("CHEQUE", payMethod.PM_Name) ? "fa fa-keyboard-o" :
                                                                                                this.findInName("TRANS", payMethod.PM_Name) ? "fa fa-exchange" :
                                                                                                    this.findInName("NOTA ", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                        this.findInName("CRÉDITO", payMethod.PM_Name) ? "fa fa-credit-card" :
                                                                                                            ""
                                                                                    }
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                </td>

                                                                                <td className='p-2 text-left small'>
                                                                                    {
                                                                                        this.findInName("EFECTIVO", payMethod.PM_Name) ? "EFECTIVO" :
                                                                                            this.findInName("CHEQUE", payMethod.PM_Name) ? "CHEQUE" :
                                                                                                this.findInName("TRANS", payMethod.PM_Name) ? "TRANSFERENCIA" :
                                                                                                    this.findInName("NOTA", payMethod.PM_Name) ? "NOTA DE CRÉDITO" :
                                                                                                        this.findInName("TARJ", payMethod.PM_Name) ? "TARJETA" :
                                                                                                            this.findInName("CRÉDITO", payMethod.PM_Name) ? "CRÉDITO" :
                                                                                                                payMethod.PM_Name
                                                                                    }
                                                                                </td>
                                                                                <td className='p-2 text-right small'>{CURRENCY + ' ' + FORMAT_NUMBER.new(payMethod.Amount)}</td>
                                                                                <td className='p-2 text-center' style={{ width: "60px" }}>
                                                                                    <i className="fa fa-trash-o cursor-pointer" style={{ color: "#dc3545" }} onClick={() => this.RemovePaymentSale(index)} />

                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className='mt-3 mb-2'>
                                                    <span>Comentarios:</span>
                                                        <div id="grupo__descriptionIn">
                                                            <div className="input-group ">
                                                                <textarea
                                                                    id="descriptionIn"
                                                                    className="form-control form__input"
                                                                    style={{height: "147px"}}
                                                                    aria-label="With textarea"
                                                                    placeholder=""
                                                                    value={cashMovementModel ? cashMovementModel.comment : ''}
                                                                    onChange={(event) => ChangeComment(event.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="mb-2">
                                        <h3 className="title mt-2">Total a {Action && Number(Action) === 1 ? 'ingresar' : 'retirar'}: </h3>
                                        <div className="card" style={{ fontSize: "clamp(1.5rem, 5vw, 3rem)", background: (Action && Number(Action) === 1 ? '#00800012' : '#80000012'), border: "none", boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                            <div className="text-center p-3">
                                                <span style={{ color: (Action && Number(Action) === 1 ? 'green' : 'maroon') }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.TotalMoneyMovement)}</span>

                                            </div>
                                        </div>

                                    </div>
                                   
                                </form>
                            </div>
                            <div className="modal-footer">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-6 col-sm-6 mb-2 mb-sm-0">
                                        <button type="button" className="btn btn-secondary btn-block" data-dismiss="modal" onClick={ newOrderModel.MoneyMovements.length>0? () =>{this.RemovePaymentSale(0); CancelMoneyMovement()} : CancelMoneyMovement}>Cancelar</button>
                                        </div>
                                        <div className="col-6 col-sm-6">
                                        <button className={"btn btn-block " + (Action && Number(Action) === 1? " btn-success " : " btn-danger ")} type="submit" data-toggle="modal" onClick={SendCashMovement}>{Action && Number(Action) === 1 ? 'Ingresar' : 'Retirar'}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationModal
                    idValidation="vmCashInModal"
                    message={"¿Seguro que quiere continuar?"}
                    idModalOrigin="#moneyMovementsModal"
                    idModalDestiny="#refMoveCashModal"
                    eventOnclick={SendCashMovement} />
            </div>
        );
    }
}

export default MoneyMovements;